const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

const RestaurantForm = require('app/restaurant/Form');

const RestaurantPriceAndStockCopyForm = require('app/restaurant/copy/PriceAndStockForm');
const RestaurantRangeAndDeliveryDayCopyForm = require('app/restaurant/copy/RangeAndDeliveryDayForm');

class InfoTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'restaurant': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.restaurant = this.settings.restaurant;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.loadData();
    }

    onDOMReady(){
        this.infosForm.onDOMReady();
    }

    loadData(){
        var self = this;

        let queries = [
            this.buildRestaurantQuery(),
            this.buildSellerQuery(),
            this.buildRestaurantsQuery()
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildTab(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildRestaurantQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'id',

            //general form
            'siren',
            'name',
            'lastName',
            'firstName',
            'address',
            'addressComplement',
            'postalCode',
            'city',

            //billing form
            'billingStatus',
            'billingPeriods { begin end levy }',
            'seller { id }',

            //software form
            'applicationStatus',
            'analyseDisplayMode',
            'orderType',
            'orderLimit',
            'orderByMailStatus',
            'type',
            'preset',

            //contact form
            'email',
            'phone',
            'info { website linkedin twitter facebook instagram }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurant',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    buildSellerQuery(){
        var self = this;


        let filters = {
            //'type': "agentco"
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
        };

        let fields = [
            'id',
            'user { lastName firstName }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'sellers',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildTab(data){
        
        this.restaurant = data.restaurant;
        this.restaurants = data.restaurants.edges;

        if(!this.restaurant.info){
            this.restaurant.info = {
                'website': null,
                'linkedin': null,
                'twitter': null,
                'facebook': null,
                'instagram': null,
            };
        }
        this.sellers = data.sellers.edges;

        this.$container
        .html('')
        .append(this.buildInfosForm())
        .append(
            $('<hr/>')
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.buildPriceAndStockCopyForm())
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.buildRangeAndDeliveryDayCopyForm())
            )
        );

        this.onDOMReady();
    }

    buildInfosForm(){

        this.infosForm = new RestaurantForm({
            'restaurant': this.restaurant,
            'sellers': this.sellers
        });

        return this.infosForm.getForm();
    }

    buildRestaurantsQuery(){
        var self = this;


        let filters = {
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'orderBy': 'name',
            'dir': "ASC",
            'filter': filters,
        };

        let fields = [
            'id',
            'name',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurants',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }
    
    buildPriceAndStockCopyForm(){

        this.priceAndStockCopyForm = new RestaurantPriceAndStockCopyForm({
            'restaurant': this.restaurant,
            'restaurants': this.restaurants,
        });

        return this.priceAndStockCopyForm.getForm();
    }

    buildRangeAndDeliveryDayCopyForm(){
        this.rangeAndDeliveryDayCopyForm = new RestaurantRangeAndDeliveryDayCopyForm({
            'restaurant': this.restaurant,
            'restaurants': this.restaurants,
        });

        return this.rangeAndDeliveryDayCopyForm.getForm();
    }
}

module.exports = InfoTab;

